// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"963":"c2e05050","1410":"c2e05050","7792":"2bf1de23"}[chunkId] + ".chunk.css";
};